import React, { useEffect, useRef, useState } from "react";
import {
  Grid,
  Tooltip,
  Button,
  Typography,
  Box,
  Paper,
  Backdrop,
  CircularProgress,
  withStyles,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  createTheme,
  ThemeProvider,
  MuiThemeProvider,
} from "@material-ui/core";
import PageTitle from "../../../../components/PageTitle/PageTitle";
import useStyles from "../../../../themes/style.js";
import { IoChevronDownSharp } from "react-icons/io5";
import axios from "axios";
import { useNotification } from "../../../../hooks/useNotification.js";
import excel_icon from "../../../../images/svg/excel-icon.svg";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "../../../../css/view-resume.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import moment from "moment";
import MUIDataTable from "mui-datatables";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { BsFillInfoCircleFill } from "react-icons/bs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoMdCheckmarkCircleOutline } from "react-icons/io"
import {useHistory} from "react-router-dom";
import { Alert, AlertTitle } from "@mui/material";

const customTheme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: "red", // Change header background
          color: "#fff", // Change header text color
          fontWeight: "bold",
          textAlign: "center",
        },
        fixedHeader: {
          background: "red",
        },
      },
    },
  },
});

const GeneratePayslip = () => {
  const classes = useStyles();
  const calendarRef = useRef(null);
  const history = useHistory()
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [selectedFile, setSelectedFile] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");
  const handleNotificationCall = useNotification();
  const [loader, setLoader] = useState(false);

  const token = localStorage.getItem("token");
  const [empPayslipData, setEmpPayslipData] = useState([]);
  const [payslipData, setPayslipData] = useState([]);
  const [payslipGenerateDate, setPayslipGenerateDate] = useState(new Date());
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [payslipUploadModal, setPayslipUploadModal] = useState(false);

  const [downloadExcelData, setDownloadExcelData] = useState([]);

  const handlePayslipMonthChange = (date) => {
    setCalendarOpen(!calendarOpen);
    setPayslipGenerateDate(date);
  };
  const handlePayslipCalendarOpen = (e) => {
    e.preventDefault();
    setCalendarOpen(!calendarOpen);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setCalendarOpen(false);
      }
    }

    if (calendarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [calendarOpen]);

  const uploadAndConvertXlsx = async (event) => {
    try {
      const target = event.target;
      const file = target.files[0];
      setLoader(true);

      if (!file.name.endsWith(".xlsx")) {
        setLoader(false);
        handleNotificationCall(
          "error",
          "Invalid file format. Please select an XLSX file",
        );
        return;
      }

      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const data = e.target?.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const records = XLSX.utils.sheet_to_json(sheet);

          console.log("Data Records:", records);
          setEmpPayslipData(records);
        };

        reader.readAsBinaryString(file);
        console.log("Records:", reader.readAsBinaryString(file));
      } else {
        handleNotificationCall("error", "Only choose xlsx format");
        setLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setLoader(false);
    }
  };

  const handleUpload = async (file) => {
    if (!selectedFile) {
      setUploadStatus("Please select a file to upload.");
      return;
    }

    var fileName = file.name.split(".").pop();

    if (fileName !== "pdf") {
      handleNotificationCall("error", "Invalid File Format");
      return;
    }

    const formData = new FormData();
    formData.append("document", file);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}admin/uploadPolicyHandBook`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        },
      );
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchData();
      }
    } catch (error) {
      setUploadStatus(
        `Upload failed: ${error.response?.data?.message || error.message}`,
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  function formatToINR(amount) {
    const currecyData = parseFloat(Math.round(amount)).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return currecyData;
  }

  const handleGeneratePayslip = async () => {
    const monthIndex = new Date(payslipGenerateDate).getMonth();
    const fullyear = new Date(payslipGenerateDate).getFullYear();
    try {
      setLoader(true);

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}payslip/generateBulkPayslips`,
        {
          monthIndex: monthIndex,
          year: fullyear,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        setPayslipUploadModal(false);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const fetchData = async () => {
    const monthIndex = new Date(payslipGenerateDate).getMonth();
    const fullyear = new Date(payslipGenerateDate).getFullYear();
    try {
      setLoader(true);

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}payslip/getPayslipExcelData`,
        {
          monthIndex: monthIndex,
          year: fullyear,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const masterValues = responseData.masterValues;
        const grossValues = responseData.grossValues;
        const deductionValues = responseData.deductionValues;
        setPayslipData(responseData);

        const downloadableData = responseData.map((item) => ({
          Name: item.user.firstName + " " + item.user.lastName,
          Email: item.user.email,
          "Join Date": moment(item.user.joinningDate).format("YYYY-MM-DD"),
          "Mode of Payment": item.isProcessed.status
            ? item.isProcessed.modeOfPayment
            : "BANK TRANSFER",
          "Days in Month": moment(payslipGenerateDate, "YYYY-M").daysInMonth(),
          "Effective Workdays":
            moment(payslipGenerateDate, "YYYY-M").daysInMonth() - item.lopCount,
          "Loss of Pay": item.lopCount,
          "Basic Allowance Arrears": item.earningValues.basicAllowanceArrears,
          "HRA Arrears": item.earningValues.hraArrears,
          "Telephone Allowance Arrears":
            item.earningValues.telephoneAllowanceArrear,
          "Conveyance Arrears": item.earningValues.conveyanceArrears,
          "Medical Allowance Arrears":
            item.earningValues.medicalAllowanceArrear,
          "Other Allowance Arrears": item.earningValues.otherAllowanceArrear,
          Bonus: item.earningValues.bonus,
          Incentives: item.earningValues.incentives,
          "Other Earnings": item.earningValues.otherEarnings,
          Arrears: item.earningValues.arrears,
          "Monthly Performance Arrears":
            item.earningValues.monthlyPerformanceArrears,
          "Statutory Bonus Arrears": item.earningValues.statutoryBonusArrears,
          "Refund For Last Month Deduction":
            item.earningValues.refundForLastMonthDeduction,
          "Role Performance Bonus": item.earningValues.rolePerformanceBonus,
          "Consultant Arrears": item.earningValues.consultantArrears,
          "Shift Allowance Arrears": item.earningValues.shiftAllowanceArrears,
          "Notice Period Deduction": item.deductionValues.noticePeriodDeduction,
          "Special Purpose Deduction":
            item.deductionValues.specialPurposeDeduction,
          "Income Tax": item.deductionValues.incomeTax,
          "Other Deduction": item.deductionValues.otherDeduction,
          "Standard Deduction": item.deductionValues.standardDeduction,
          "Total Gross": item.totalGross,
          "Total Deduction": item.totalDeduction,
          "Net Value": item.netValue,
        }));
        setDownloadExcelData(downloadableData);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const exportToExcel = () => {
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(downloadExcelData);

    // Create a workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate the Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // Save the file
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(
      blob,
      `employee_payslip_${moment(payslipGenerateDate).format(
        "DD-MM-YYYY",
      )}.xlsx`,
    );
    history.push('/app/employee/payroll/upload-payslip?tab=1')
  };

  const HeaderElements = () => (
    <Box display="flex" alignItems="baseline" gridGap={4}>
      <Typography>Total : {empPayslipData.length}</Typography>
    </Box>
  );

  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{shortMonth}</span>;
  };

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="end"
            alignItems="center"
            gridColumnGap={8}
            width="100%"
            ref={calendarRef}
          >
            <Button
              variant="contained"
              color="primary"
              size="small"
              component="label"
              onClick={() => setPayslipUploadModal(true)}
            >
              Generate
            </Button>

            <Button
              variant="outlined"
              size="small"
              color="primary"
              className="example-custom-input"
              endIcon={<IoChevronDownSharp />}
              onClick={handlePayslipCalendarOpen}
            >
              {moment(payslipGenerateDate).format("MMM-yyyy")}
            </Button>
            {calendarOpen && (
              <Box
                position="relative"
                zIndex={111}
                className="payslip-month-picker-container"
              >
                <DatePicker
                  selected={payslipGenerateDate}
                  onChange={handlePayslipMonthChange}
                  renderMonthContent={renderMonthContent}
                  showMonthYearPicker
                  dateFormat="MM/yyyy"
                  wrapperClassName="payslip-month-calender"
                  popperClassName="payslip-month-calender-popper"
                  inline
                />
              </Box>
            )}
            <Button
              variant="contained"
              color="primary"
              size="small"
              component="label"
              onClick={exportToExcel}
            >
              Export Data
              {/* <input
                type="file"
                hidden
                multiple
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                onChange={uploadAndConvertXlsx}
              /> */}
            </Button>
          </Box>
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" spacing={2}>
        <Grid item xs={12}>
          <Box className={classes.generatePayslipTable}>
            <MUIDataTable
              title=""
              options={{
                textLabels: {
                  body: {
                    noMatch: "Oops! Matching record could not be found",
                  },
                },
                pagination: false,
                sort: false,
                selectableRows: "none",
                search: false,
                filter: false,
                download: false,
                print: false,
                fixedSelectColumn: true,
                customToolbar: () => (
                  <>
                    <HeaderElements />
                  </>
                ),
                responsive: mobileQuery === true ? "vertical" : "standard",
              }}
              columns={[
                {
                  name: "S.No",
                  options: {
                    setCellProps: (value, tableMeta) => {
                      const rowIndex = tableMeta;
                      const isProcessed =
                        payslipData[rowIndex]?.isProcessed?.status;
                      return {
                        style: {
                          position: "sticky",
                          left: 0, // Adjust based on column width
                          background: isProcessed ? "#E1FFBB" : "#fff",
                          zIndex: 1001,
                        },
                      };
                    },
                    setCellHeaderProps: () => ({
                      style: {
                        position: "sticky",
                        left: 0,
                        background: "#fff",
                        zIndex: 1002,
                      },
                    }),
                  },
                },
                {
                  name: "Name",
                  options: {
                    setCellProps: (value, tableMeta) => {
                      const rowIndex = tableMeta;
                      const isProcessed =
                        payslipData[rowIndex]?.isProcessed?.status;
                      console.log(
                        "is===",
                        payslipData[rowIndex],
                        tableMeta,
                        value,
                      );
                      return {
                        style: {
                          position: "sticky",
                          left: 50, // Adjust based on column width
                          background: isProcessed ? "#E1FFBB" : "#fff",
                          zIndex: 1001,
                          borderRight: "1px solid #e0e0e0",
                          boxShadow:
                            "inset rgb(195 193 193 / 20%) -2px 0px 0px 0px",
                        },
                      };
                    },
                    setCellHeaderProps: () => ({
                      style: {
                        position: "sticky",
                        left: 50,
                        background: "#fff",
                        zIndex: 1002,
                      },
                    }),
                  },
                },
                {
                  name: "Email",
                },
                {
                  name: "Join Date",
                },
                {
                  name: "Mode of Payment",
                },
                {
                  name: "Days in Month",
                },
                {
                  name: "Effective Workdays",
                },
                {
                  name: "LOP Count",
                },
                {
                  name: "Basic Allowance Arrears",
                },
                {
                  name: "HRA Allowance Arrears",
                },
                {
                  name: "Telephone Allowance Arrears",
                },
                {
                  name: "Conveyance Arrears",
                },
                {
                  name: "Medical Allowance Arrears",
                },
                {
                  name: "Other Allowance Arrears",
                },
                {
                  name: "Bonus",
                },
                {
                  name: "Incentives",
                },
                {
                  name: "Other Earnings",
                },
                {
                  name: "Arrears",
                },
                {
                  name: "Consultant Arrears",
                },
                {
                  name: "Monthly Performance Arrears",
                },
                {
                  name: "Statutory Bonus Arrears",
                },
                {
                  name: "Refund For Last Month Deduction",
                },
                {
                  name: "Role Performance Bonus",
                },
                {
                  name: "Shift Allowance Arrears",
                },
                {
                  name: "Notice Period Deduction",
                },
                {
                  name: "Special Purpose Deduction",
                },
                {
                  name: "IncomeTax",
                },
                {
                  name: "Other Deduction",
                },
                {
                  name: "Standard Deduction",
                },
                {
                  name: "Total Gross",
                },
                {
                  name: "Total Deduction",
                },
                {
                  name: "Net Value",
                },
              ]}
              data={payslipData.map((item, index) => {
                return [
                  <>{index + 1}</>,
                  <Box
                    sx={{
                      color: item.isProcessed.status ? "#1F4529" : "inherit",
                      position: "relative",
                    }}
                  >
                    {`${item.user.firstName} ${item.user.lastName}`}

                    {item.isProcessed.status && (
                      <Box
                        component="span"
                        sx={{ position: "absolute", top: -16, right: -12 }}
                      >
                        <IoMdCheckmarkCircleOutline size={20} color="#1F4529" />
                      </Box>
                    )}
                  </Box>,
                  item.user.email,
                  moment(item.user.joinningDate).format("YYYY-MM-DD"),
                  item.isProcessed.status
                    ? item.isProcessed.modeOfPayment
                    : "BANK TRANSFER",
                  moment(payslipGenerateDate, "YYYY-M").daysInMonth(),
                  item.effective_work_days,
                  item.lopCount,
                  formatToINR(item.earningValues.basicAllowanceArrears),
                  formatToINR(item.earningValues.hraArrears),
                  formatToINR(item.earningValues.telephoneAllowanceArrear),
                  formatToINR(item.earningValues.conveyanceArrears),
                  formatToINR(item.earningValues.medicalAllowanceArrear),
                  formatToINR(item.earningValues.otherAllowanceArrear),
                  formatToINR(item.earningValues.bonus),
                  formatToINR(item.earningValues.incentives),
                  formatToINR(item.earningValues.otherEarnings),
                  formatToINR(item.earningValues.arrears),
                  formatToINR(item.earningValues.consultantArrears),
                  formatToINR(item.earningValues.monthlyPerformanceArrears),
                  formatToINR(item.earningValues.statutoryBonusArrears),
                  formatToINR(item.earningValues.refundForLastMonthDeduction),
                  formatToINR(item.earningValues.rolePerformanceBonus),
                  formatToINR(item.earningValues.shiftAllowanceArrears),
                  formatToINR(item.deductionValues.noticePeriodDeduction),
                  formatToINR(item.deductionValues.specialPurposeDeduction),
                  formatToINR(item.deductionValues.incomeTax),
                  formatToINR(item.deductionValues.otherDeduction),
                  formatToINR(item.deductionValues.standardDeduction),
                  formatToINR(item.totalGross),
                  formatToINR(item.totalDeduction),
                  formatToINR(item.netValue),
                ];
              })}
            />
          </Box>
        </Grid>
      </Grid>

      <Dialog
        open={payslipUploadModal}
        fullWidth
        maxWidth="xs"
        onClose={() => {
          setPayslipUploadModal(false);
        }}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>{`Generate Payslip ${moment(payslipGenerateDate).format('MMM YYYY')}`}</DialogTitle>
        <DialogContent>
          <Box>
            <Typography variant="body2">
              Processed payslips only send through this action.
            </Typography>
            <Alert icon={false} severity="warning">
              <AlertTitle>Note:</AlertTitle>
              <Box component="ul" style={{ listStyle: "disc" }}>
                <Typography component="li">
                  Once the payslip is sent, you will not be able to make any
                  further changes to the payslip details.
                </Typography>
                <Typography component="li">
                  Please review the payslip carefully before generating.
                </Typography>
              </Box>
            </Alert>
          </Box>
        </DialogContent>
        <DialogActions style={{ padding: "12px 24px" }}>
          <Button
            onClick={() => {
              setPayslipUploadModal(false);
            }}
            variant="contained"
            color="secondary"
            size="small"
          >
            Cancel
          </Button>
          <Button variant="contained" color="primary" size="small" onClick={handleGeneratePayslip}>
            Send
          </Button>
        </DialogActions>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default GeneratePayslip;
